import { c as _c } from "react/compiler-runtime";
import { useState, useCallback } from 'react';
import { udExpiringLocalStorage } from '@udemy-v2/utils';
const browserStore = udExpiringLocalStorage('frontends-course-landing-page', 'review-helpfulness');
export function makeStorageKey(reviewId: number): string {
  return `udemy/review/${reviewId}/helpfulness`;
}
export interface UseHelpfulnessProps {
  reviewId: number;
  viewPosition: number;
  courseId: number;
  page: number;
  filterState: {
    rating: number | null;
    term: string | null;
  };
  store?: typeof browserStore;
}
export function useHelpfulness(t0) {
  const $ = _c(15);
  const {
    reviewId,
    viewPosition,
    courseId,
    page,
    filterState,
    store: t1
  } = t0;
  const store = t1 === undefined ? browserStore : t1;
  let t2;
  if ($[0] !== reviewId || $[1] !== store) {
    t2 = () => (store.get(makeStorageKey(reviewId)) ?? null) as boolean | null;
    $[0] = reviewId;
    $[1] = store;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [value, setValue] = useState(t2);
  let t3;
  if ($[3] !== reviewId || $[4] !== store || $[5] !== value) {
    t3 = newValue => {
      if (newValue === value) {
        store.delete(makeStorageKey(reviewId));
        setValue(null);
      } else {
        store.set(makeStorageKey(reviewId), newValue);
        setValue(newValue);
      }
    };
    $[3] = reviewId;
    $[4] = store;
    $[5] = value;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onToggle = t3;
  let t4;
  if ($[7] !== courseId || $[8] !== filterState || $[9] !== onToggle || $[10] !== page || $[11] !== reviewId || $[12] !== value || $[13] !== viewPosition) {
    t4 = {
      value,
      onToggle,
      reviewId,
      viewPosition,
      courseId,
      page,
      filterState
    };
    $[7] = courseId;
    $[8] = filterState;
    $[9] = onToggle;
    $[10] = page;
    $[11] = reviewId;
    $[12] = value;
    $[13] = viewPosition;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}